export default function SectionHeader({
  eyebrow,
  title,
  intro,
  align = "left",
  accent = "#FF007F",
  testid,
}) {
  return (
    <div
      data-testid={testid}
      className={`${align === "center" ? "text-center mx-auto" : "text-left"} max-w-4xl`}
    >
      {eyebrow && (
        <div
          className={`inline-flex items-center gap-2 bg-white border-2 border-[#1A1A1A] rounded-full px-3 py-1 nb-shadow-sm`}
        >
          <span
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: accent }}
          />
          <span className="text-xs font-bold tracking-[0.2em] uppercase">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter text-[#1A1A1A]">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-base md:text-lg text-[#4A4A4A] font-medium leading-relaxed max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
}
